export const getElementByXpath = (path) =>
  document.evaluate(
    path,
    document,
    null,
    XPathResult.FIRST_ORDERED_NODE_TYPE,
    null
  ).singleNodeValue;

export const replaceDynamicAndCompare = (actualStr, templateStr) => {
  templateStr = templateStr.endsWith("/")
    ? templateStr.slice(0, templateStr.length - 1)
    : templateStr;
  actualStr = actualStr.endsWith("/")
    ? actualStr.slice(0, actualStr.length - 1)
    : actualStr;

  const templateParts = templateStr.split("/");
  const actualParts = actualStr.split("/");
  if (templateParts.length !== actualParts.length) {
    return false;
  }
  for (let i = 0; i < templateParts.length; i++) {
    if (templateParts[i].startsWith("{{") && templateParts[i].endsWith("}}")) {
      actualParts[i] = templateParts[i];
    }
  }
  return actualParts.join("/") === templateStr;
};
